module.exports = __webpack_public_path__ + "static/media/icon-catalog-slabs.903e69ec.svg";